module.exports = __webpack_public_path__ + "html-editor-sprite.32efa5ff8e90756c05b6.png";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/img/html-editor-sprite.png
// module id = ../../../../../client/assets/img/html-editor-sprite.png
// module chunks = styles